import api from '@/lib/axios';
import { clearLegacyAuthStorage } from '@/lib/clearLegacyAuthStorage';

function readCookie(name) {
  try {
    const prefix = `${name}=`;
    const hit = document.cookie.split(';').map((c) => c.trim()).find((c) => c.startsWith(prefix));
    return hit ? decodeURIComponent(hit.slice(prefix.length)) : null;
  } catch {
    return null;
  }
}

/**
 * Super-Admin wechselt in ein anderes Konto.
 * @param {string} userId
 * @param {{ to?: '/m' | '/' }} [opts] — Ziel nach Wechsel; '/m' öffnet immer den Companion.
 */
export async function startImpersonation(userId, opts = {}) {
  const r = await api.post(`/admin/rbac/users/${userId}/impersonate`);
  const { user: target, is_app_only } = r.data || {};
  clearLegacyAuthStorage();
  const forceMobile = opts.to === '/m';
  if (forceMobile || is_app_only) {
    try { localStorage.removeItem('user'); } catch { /* ignore */ }
    window.location.href = '/m';
  } else {
    try { localStorage.setItem('user', JSON.stringify(target)); } catch { /* ignore */ }
    window.location.href = '/';
  }
  return r.data;
}

/**
 * Beendet Kontowechsel via API (setzt HttpOnly-Cookies neu).
 */
export async function stopImpersonation() {
  try {
    await api.post('/admin/rbac/impersonate/stop');
  } catch {
    /* cookie may already be expired — still clear client flags */
  }
  clearLegacyAuthStorage();
  const onMobile = typeof window !== 'undefined'
    && window.location.pathname.startsWith('/m');
  window.location.href = onMobile ? '/m' : '/';
}

export function isImpersonating() {
  return readCookie('mamv_impersonating') === '1';
}

/** Epoch-ms from non-HttpOnly cookie set by the server (not a JWT). */
export function getImpersonationExpiresAt() {
  const raw = readCookie('mamv_imp_expires');
  if (!raw) return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
}
